<template>
  <div class="home">
    <h1>快速计算训练</h1>
  </div>
</template>
